import { render, staticRenderFns } from "./dataSpectaculars.vue?vue&type=template&id=57855704&scoped=true"
import script from "./dataSpectaculars.vue?vue&type=script&lang=js"
export * from "./dataSpectaculars.vue?vue&type=script&lang=js"
import style0 from "./dataSpectaculars.vue?vue&type=style&index=0&id=57855704&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57855704",
  null
  
)

export default component.exports